import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { Configuration } from 'src/app/_models/configuration';
import { AlertService } from 'src/app/_services/alert.service';
import { ConfigurationService } from 'src/app/_services/configuration.service';
import { DialogDeleteConfirmComponent } from 'src/app/dialog-delete-confirm/dialog-delete-confirm.component';

@Component({
  selector: 'app-admin-config',
  templateUrl: './admin-config.component.html',
  styleUrls: ['./admin-config.component.scss']
})



export class AdminConfigComponent implements OnInit {

  allConfig = [];
  adminConfigForm: FormGroup;
  isConfiguration: boolean = true;
  numberType = ["SIGNATURE_VERSION", "VIEW_DOCUMENT_EXPIRATION","RETRIEVAL_DAYS","FILE_SIZE_LIMIT","BULK_UPDATE_LIMIT"];
  booleanType = ["FULLTEXT_SEARCH","GLACIER_ARCHIVAL","BACKGROUND_TASK_ENABLED","METADATA_VERSIONING","POLICY_ARCHIVAL","ENABLE_WATERMARK"];
  passwordType = ["ACCESS_KEY", "ACCESS_SECRET", "OPENSEARCH_PASSWORD", "PASSWORD"];
  adminShowFields = ["ENABLE_WATERMARK", "BULK_UPDATE_LIMIT"];

  constructor(
    private configurationService: ConfigurationService,
    private alertService: AlertService
  ) { }

  ngOnInit() {
    this.getConfiguration()
  }

  newForm() {
   this.adminConfigForm = new FormGroup({
      key: new FormControl('', Validators.required),
      value: new FormControl('', Validators.required),
    })
  }

  createValuesForm(properties) {
    var formControlObject = {}
    properties.forEach(property => {
      formControlObject[property] = new FormArray([this.initValues()])
    });
    this.adminConfigForm = new FormGroup(
      formControlObject
    )
  }

  initValues() {
    return new FormGroup({
      value: new FormControl('', Validators.required)
    })
  }

  addNewValue(property) {
    const control = <FormArray>this.adminConfigForm.get(property);
    control.push(this.initValues());
  }

  getValues(form, property) {
    return form.controls[property].controls;
  }

  deleteForm(index: number, property) {
    this.valuesArray(property).removeAt(index);
  }

  valuesArray(property) {
    return <FormArray>this.adminConfigForm.get(property)
  }

  getConfiguration() {
    this.configurationService.getConfiguration().subscribe(categories => {      
      for (let index in categories) {
        if (this.adminShowFields.includes(index)) {   
          if (this.booleanType.includes(index)) {
            if (categories[index].toString() === "true") {
              this.allConfig.push({"key": index, "value": true, "type" : "boolean"});
            } else {
              this.allConfig.push({"key": index, "value": false, "type" : "boolean"});
            }
          } else if (this.numberType.includes(index)) {
            this.allConfig.push({"key": index, "value": categories[index], "type" : "number"});
          } else if (this.passwordType.includes(index)) {
            this.allConfig.push({"key": index, "value": categories[index], "type" : "password"});
          } else {
            this.allConfig.push({"key": index, "value": categories[index], "type" : "string"});
          }
        }
      }
      this.allConfig.forEach(feature => {
        if (feature.type == "string") {
          feature.value = feature.value.replace(/^"|"$/g, '');
        }
      });  
    });

    
  }

  addConfiguration() {
    this.configurationService.addConfiguration().subscribe(categories => {
      this.allConfig = categories;
      this.createValuesForm(categories);
    })
  }

  updateConfiguration() { 
    let request = {};
    this.allConfig.forEach(feature => {
      request[feature.key] = feature.value;
    });
    console.log(request);
    this.configurationService.editConfiguration(request).subscribe(categories => {
      this.alertService.success("Settings value updated successfully");      
    });
  }

  updateValue(feature) {
    console.log(feature)
  }
  

}